import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import {
  CODIGO_TIPO_DOC_CC,
  CODIGO_TIPO_DOC_CE,
  CODIGO_TIPO_DOC_PA,
  CODIGO_TIPO_DOC_PPT,
  DOC_CC_PATTERN,
  DOC_CC_MESSAGE,
  DOC_CE_PATTERN,
  DOC_CE_MESSAGE,
} from './validation.constants';

export interface TipoDocIdentidadParaValidacion {
  idTipoDocIdentidad?: number;
  codigo?: string;
}

/**
 * Validador de número de documento según tipo (CC, CE, PA, PPT).
 * Usa el codigo que trae el tipo de documento del API.
 */
export function numeroDocumentoPorTipoDocValidator(
  getTipos: () => TipoDocIdentidadParaValidacion[],
  idTipoDocControlName: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value == null || String(value).trim() === '') {
      return null;
    }
    const parent = control.parent as FormGroup | null;
    if (!parent) return null;
    const idTipoRaw = parent.get(idTipoDocControlName)?.value;
    if (idTipoRaw == null || idTipoRaw === '') return null;
    const tipos = getTipos();
    const idTipoNum = Number(idTipoRaw);
    const tipo = tipos.find((t) => t.idTipoDocIdentidad === idTipoNum || t.idTipoDocIdentidad === idTipoRaw);
    const codigo = tipo?.codigo;
    const str = String(value).trim().toUpperCase();
    if (codigo === CODIGO_TIPO_DOC_CC) {
      return DOC_CC_PATTERN.test(str)
        ? null
        : { documentPattern: true, codigoTipo: codigo };
    }
    if (codigo === CODIGO_TIPO_DOC_CE || codigo === CODIGO_TIPO_DOC_PA || codigo === CODIGO_TIPO_DOC_PPT) {
      return DOC_CE_PATTERN.test(str)
        ? null
        : { documentPattern: true, codigoTipo: codigo };
    }
    return null;
  };
}

/**
 * Mensaje de error para documentPattern según codigoTipo.
 */
export function getDocumentPatternMessage(control: AbstractControl | null): string {
  if (!control?.hasError('documentPattern')) return '';
  const codigo = control.getError('codigoTipo') as string | undefined;
  if (codigo === CODIGO_TIPO_DOC_CC) return DOC_CC_MESSAGE;
  if (codigo === CODIGO_TIPO_DOC_CE || codigo === CODIGO_TIPO_DOC_PA || codigo === CODIGO_TIPO_DOC_PPT) return DOC_CE_MESSAGE;
  return 'El número de documento no cumple el formato requerido para el tipo seleccionado';
}
